import { ScrollTrigger }        from "gsap/ScrollTrigger";
const axios             = require('axios');
import ScrollEvents from './ScrollEvents'

const AjaxLoadPage = function()
{
    const $elLoad       = $("#loaderPage");
    const _body         = $("html,body");
    // const _menu         = $("#nav-header");
    const _header       = $("#header");
    const _introLayer   = $("#layerIntroPage");


    const pageLoader = function() {

        _introLayer.addClass('motion-in');
        _introLayer.addClass('anime');            
            setTimeout(() => {
                // setTimeout(()=>{
                    _introLayer.addClass('motion-out');
                    _body.removeClass('no-scroll body-content-loading');
                    // setTimeout(() => {
                        _header.addClass('motion-in');
                        ScrollEvents.animeTextIntro();
                        if(document.querySelector('.webdoor')){
                            ScrollEvents.parallaxWebdoor();
                        }
                        setTimeout(function () {
                            ScrollTrigger.refresh();
                        }, 550);
                    // }, 500);                    
                // },1800) 
            }, 1000);

    }


    return {
        init : function(status){

            pageLoader();


        }
    }

}();

export default AjaxLoadPage;
